import { format } from "date-fns";
import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";
import { itemOrderStatusClasses } from "modules/ItemOrderStatusClasses";

import "../ItemOrderStatuses.scss";

const StatusTemplate = ({ status, updatedDate }: IItemOrderStatusViewModel): any => (
  <>
    <span className={`${itemOrderStatusClasses[status]} fw-bold`}>
      {status}
    </span>
    {updatedDate !== null && updatedDate !== undefined && (
      <>
        <br />
        <span>
          {format(new Date(updatedDate), "dd MMM yyyy")}
        </span>
      </>
    )}
  </>
);
export default StatusTemplate;
